import React from 'react';
import { useDispatch } from 'react-redux';
import { Image } from 'styled-minimal';
import { logOut } from 'actions';
import { HeaderContainer, HeaderWrapper, Actions, Action } from './headerStyles';

interface HeaderProps {
  onSubmitClick: () => void;
}

export default function Header({ onSubmitClick }: HeaderProps) {
  const dispatch = useDispatch();

  const handleClickLogout = () => {
    dispatch(logOut());
  };

  return (
    <HeaderWrapper data-testid="Header">
      <HeaderContainer>
        <Actions>
          <Action onClick={handleClickLogout}>
            <Image
              width={32}
              src={`${process.env.PUBLIC_URL}/media/images/start.png`}
              alt="start over"
            />
            <span>Start Over</span>
          </Action>
          <Action onClick={onSubmitClick}>
            <Image
              style={{ marginLeft: '4px', marginRight: '4px' }}
              width={26}
              src={`${process.env.PUBLIC_URL}/media/images/submit-interview.svg`}
              alt="interview complete"
            />
            <span>Interview Complete</span>
          </Action>
        </Actions>
      </HeaderContainer>
    </HeaderWrapper>
  );
}
